import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CombinedReadonlyDirective } from '../../../../../../../directives/combined-readonly.directive';
import { ActivityEditDialogData, ActivityNcc, NccData } from '../../../../../../../models';
import { InputMonetaryAmountComponent } from '../../../../../../shared/input-monetary-amount/input-monetary-amount.component';
import { InputPhoneComponent } from '../../../../../../shared/input-phone/input-phone.component';
import { InputTimeComponent } from '../../../../../../shared/input-time/input-time.component';
import { NccActivityMapper, isEntity } from '../../../../../../shared/utils';
import { ActivityEditDialogBase } from '../../activity-edit-dialog-base';

@Component({
  selector: 'app-ncc-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    DragDropModule,
    TranslateModule,
    InputPhoneComponent, InputMonetaryAmountComponent, InputTimeComponent,
    CombinedReadonlyDirective
  ],
  templateUrl: './ncc-edit-dialog.component.html'
})
export class NccEditDialogComponent extends ActivityEditDialogBase<ActivityNcc> {


  form!: FormGroup;

  activityNcc!: ActivityNcc;

  constructor(
    private nccActivityMapper: NccActivityMapper,
    dialogRef: MatDialogRef<NccEditDialogComponent>,
    confirmationDialog: MatDialog,
    translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) override data: ActivityEditDialogData
  ) {
    super(dialogRef, confirmationDialog, translateService, data);
    if (isEntity(data.activityData)) {
      this.activityNcc = this.nccActivityMapper.mapFromEntityToActivity(data.activityData as NccData);
    } else {
      this.activityNcc = data.activityData as ActivityNcc;
    }
    this.initializeEditForm();

  }

  private initializeEditForm() {
    this.form = new FormGroup({
      name: new FormControl({ value: this.activityNcc.name, disabled: true }),

      phone: new FormControl(
        this.activityNcc?.phone ?? null, [Validators.required]),

      startingPoint: new FormControl(
        this.activityNcc?.startingPoint ?? null, [Validators.required, Validators.maxLength(30)]),

      startTime: new FormControl(
        this.activityNcc?.startTime ?? null, [Validators.required]),

      endTime: new FormControl(
        this.activityNcc?.endTime ?? null, [Validators.required]),

      arrivalPoint: new FormControl(
        this.activityNcc?.arrivalPoint ?? null, [Validators.required, Validators.maxLength(30)]),

      totalPrice: new FormControl(
        this.activityNcc?.totalPrice ?? null, [Validators.required]),

      description: new FormControl(
        this.activityNcc?.description ?? null),

      disclaimer: new FormControl(
        this.activityNcc?.disclaimer ?? null),

      notes: new FormControl(
        this.activityNcc?.notes ?? null),

    });
  }

  confirm() {
    if (this.form.valid) {
      this.updateActivityFromForm();
      this.confirmAndCloseDialog(this.activityNcc);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  updateActivityFromForm() {
    if (this.activityNcc && this.form) {
      this.activityNcc.name = this.form.get('name')?.value;
      this.activityNcc.phone = this.form.get('phone')?.value;
      this.activityNcc.startingPoint = this.form.get('startingPoint')?.value;
      this.activityNcc.startTime = this.form.get('startTime')?.value;
      this.activityNcc.endTime = this.form.get('endTime')?.value;
      this.activityNcc.arrivalPoint = this.form.get('arrivalPoint')?.value;
      this.activityNcc.totalPrice = this.form.get('totalPrice')?.value;
      this.activityNcc.description = this.form.get('description')?.value;
      this.activityNcc.disclaimer = this.form.get('disclaimer')?.value;
      this.activityNcc.notes = this.form.get('notes')?.value;
    }
  }

/**
 * Get error message for label field
 */
  getLabelErrorMessage(fieldName: string): string {
    if (this.form.get(fieldName)?.hasError('required')) {
      return "required-field"
    }
    if (this.form.get(fieldName)?.hasError('maxlength')) {
      return "maxlenght-field";
    }
    return '';
  }

}
